export default __webpack_public_path__ + "static/media/Google Play - eng.01ceeeca.png";